export enum Permission {
    SUPER_ADMIN = 'superadmin',
    ADMIN = 'admin',
    MODERATOR = 'moderator',
}